import { clsx } from '@alexis/helpers/clsx';
import React, { useEffect, type PropsWithChildren } from 'react';

import { useBodyScrollable } from '../hooks/useBodyScrollable';
import styles from '../styles/components/Dialog.module.scss';

interface DialogProps {
  className?: string;
  isOpen: boolean;
  onClose?(e: React.MouseEvent<HTMLDivElement, MouseEvent>): void;
  dataTestId?: string;
}

const Dialog: React.FC<PropsWithChildren<DialogProps>> = ({
  children,
  className,
  isOpen,
  onClose,
  dataTestId,
}) => {
  const [, setIsBodyScrollable] = useBodyScrollable();

  useEffect(() => {
    if (isOpen) {
      setIsBodyScrollable(false);
    } else {
      setIsBodyScrollable(true);
    }

    return () => {
      setIsBodyScrollable(true);
    };
  }, [isOpen]);

  return (
    <div
      data-testid={dataTestId}
      className={clsx(styles.container, isOpen && styles.open, className)}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={styles.overlay}
        onClick={(e) => onClose?.(e)}
        data-testid='dialog-overlay'
      ></div>
      <div className={clsx(styles.dialog)}>{children}</div>
    </div>
  );
};

export default Dialog;
